export default __webpack_public_path__ + "static/media/sidebar-4.39c69361.jpg";